import type { Play } from "../types";
import { usePlayback } from "../hooks/usePlayback";
import { CourtBoard } from "./CourtBoard";
import { PlaybackControls } from "./PlaybackControls";
import { ArrowLeft, Copy } from "./icons";

interface PlayerViewerProps {
  play: Play;
  onBack: () => void;
  onShare: () => void;
}

export function PlayerViewer({ play, onBack, onShare }: PlayerViewerProps) {
  const playback = usePlayback(play.steps);
  const currentStep = play.steps[playback.index];

  return (
    <main className="viewer-page">
      <header className="viewer-header">
        <button className="text-button" onClick={onBack}><ArrowLeft size={18} /> 战术库</button>
        <div className="viewer-title">
          <span>{play.courtType === "half" ? "半场战术" : "全场战术"}</span>
          <h1>{play.name}</h1>
        </div>
        <button className="text-button" onClick={onShare}><Copy size={17} /> 复制链接</button>
      </header>

      <div className="viewer-layout">
        <section className="viewer-stage">
          {playback.renderedStep && <CourtBoard step={playback.renderedStep} courtType={play.courtType} />}
          <PlaybackControls
            playing={playback.playing}
            current={playback.index}
            total={play.steps.length}
            speed={playback.speed}
            onToggle={playback.toggle}
            onPrevious={playback.previous}
            onNext={playback.next}
            onReplay={playback.replay}
            onSpeed={playback.setSpeed}
          />
        </section>
        <aside className="viewer-notes">
          <p className="eyebrow">STEP {playback.index + 1} / {play.steps.length}</p>
          <h2>{currentStep.title}</h2>
          <p>{currentStep.note || "本步暂无讲解。"}</p>
          <div className="step-dots" aria-label="选择步骤">
            {play.steps.map((step, index) => (
              <button
                key={step.id}
                className={index === playback.index ? "active" : ""}
                onClick={() => playback.goTo(index)}
                aria-label={`第 ${index + 1} 步：${step.title}`}
              >{index + 1}</button>
            ))}
          </div>
          {play.description && <div className="play-description"><strong>战术说明</strong><p>{play.description}</p></div>}
        </aside>
      </div>
    </main>
  );
}
